// extracted by mini-css-extract-plugin
export default {"xsmall":"360px","small":"500px","medium":"720px","large":"1024px","largeplus":"1152px","xlarge":"1600px","container":"1920px"};